import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3cc1e226"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["title"]
const _hoisted_2 = {
  key: 0,
  class: "displayNumber"
}

import { computed, ComputedRef } from 'vue';

import BrandIcon from '@/components/icons/BrandIcon.vue';
import InitialIcon from '@/components/InitialIcon.vue';
import { AppName, BrandColors } from '@/data/Branding';
import { LimitedUserDetails } from '@/data/datatypes/UserDetails';
import { convertUUIDtoNumber } from '@/data/helpers/InitialsHelper';

const guestDisplay: string = 'Guest';

interface Props {
  user?: LimitedUserDetails;
  alt?: string;
  altDisplayName?: string;
  title?: string;
  bordered?: boolean;
  large?: boolean;
  displayNumber?: number;
}
interface Emits {
  (e: 'click', event: MouseEvent): void,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'UserIdent',
  props: {
    user: {},
    alt: {},
    altDisplayName: {},
    title: {},
    bordered: { type: Boolean, default: false },
    large: { type: Boolean },
    displayNumber: {}
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const colour: ComputedRef<string | null> = computed(() => {
  if (!props.user || (!props.user.color && !props.user.id)) {
    return null;
  }

  if (props.user.color) {
    return props.user.color;
  }

  // If the user doesn't have a colour set, then use one based on their ID
  const colorIndex = convertUUIDtoNumber(props.user.id) % BrandColors.DEFAULT_GENERATED_COLOURS.length;
  return BrandColors.DEFAULT_GENERATED_COLOURS[colorIndex];
});

const avatar: ComputedRef<string | null> = computed(() => {
  return props.user?.avatar ?? null;
});

const toInitialise: ComputedRef<string | undefined> = computed(() => {
  if (props.user && props.user.displayName) {
    return props.user.displayName;
  } else if (props.user && props.user.email) {
    return props.user.email;
  } else if (props.altDisplayName) {
    return props.altDisplayName;
  } else if (props.user && props.user.guest) {
    return guestDisplay;
  }
  return undefined;
});

const isSystem: ComputedRef<boolean> = computed(() => {
  return props.altDisplayName === AppName;
});

const identTitle: ComputedRef<string> = computed(() => {
  if (props.title) {
    return props.title;
  }
  if (!props.user) {
    return guestDisplay;
  }
  return props.user.displayName || props.user.email || guestDisplay;
});

function handleClick(event: MouseEvent): MouseEvent {
  emit('click', event);
  return event;
}

return (_ctx: any,_cache: any) => {
  return (isSystem.value)
    ? (_openBlock(), _createBlock(BrandIcon, {
        key: 0,
        class: "logo",
        name: "fullColour/appLogo",
        title: "Dashboard"
      }))
    : (_ctx.user || _ctx.alt)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "userIdent",
          title: identTitle.value,
          onClick: handleClick
        }, [
          _createVNode(InitialIcon, {
            class: _normalizeClass(["userInitial", { bordered: _ctx.bordered } ]),
            alt: _ctx.alt,
            color: colour.value,
            icon: avatar.value,
            large: _ctx.large,
            toInitialise: toInitialise.value
          }, null, 8, ["class", "alt", "color", "icon", "large", "toInitialise"]),
          (_ctx.displayNumber !== undefined)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.displayNumber), 1))
            : _createCommentVNode("", true)
        ], 8, _hoisted_1))
      : _createCommentVNode("", true)
}
}

})